import {createSelector} from '@reduxjs/toolkit'
import {RootState} from 'app/rootReducer'
import {EndpointsState} from './endpointsSlice'

function getEndpoints(state: RootState): EndpointsState {
  return state.endpoints
}

export const selectEndpoints = createSelector(
  getEndpoints,
  endpoints => endpoints,
)

export const selectedEndpointDebugMode = createSelector(
  getEndpoints,
  endpoints => {
    const {selectedEndpoints} = endpoints || {}
    return Boolean(selectedEndpoints?.debugMode)
  },
)
